const GOOGLE_OAUTH_PROMPT = 'select_account';

function absoluteUrl(pathOrUrl) {
  if (!pathOrUrl) return `${window.location.origin}/`;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const path = pathOrUrl.startsWith('/') ? pathOrUrl : `/${pathOrUrl}`;
  return `${window.location.origin}${path}`;
}

function withSelectAccountPrompt(raw) {
  const url = new URL(raw.toString());
  const existing = url.searchParams.get('prompt') || '';
  const parts = new Set(existing.split(/\s+/).filter(Boolean));
  parts.add(GOOGLE_OAUTH_PROMPT);
  url.searchParams.set('prompt', [...parts].join(' '));
  url.searchParams.set('oidc_prompt', GOOGLE_OAUTH_PROMPT);
  for (const key of ['redirect_url', 'redirect_uri', 'continue', 'url']) {
    const nested = url.searchParams.get(key);
    if (!nested) continue;
    try {
      const nestedUrl = new URL(nested);
      if (nestedUrl.hostname.includes('google')) {
        url.searchParams.set(key, withSelectAccountPrompt(nestedUrl));
      }
    } catch {
      // ignore non-URL query values
    }
  }
  return url.toString();
}

function oauthRedirectUrl(resource) {
  return (
    resource?.firstFactorVerification?.externalVerificationRedirectURL ||
    resource?.verifications?.externalAccount?.externalVerificationRedirectURL ||
    null
  );
}

async function startWithResource(resource, redirectUrlComplete, createFn) {
  const created = await createFn({
    strategy: 'oauth_google',
    redirectUrl: absoluteUrl('/sso-callback'),
    actionCompleteRedirectUrl: absoluteUrl(redirectUrlComplete),
    oidcPrompt: GOOGLE_OAUTH_PROMPT,
  });
  const raw = oauthRedirectUrl(created) || oauthRedirectUrl(resource);
  if (!raw) {
    throw new Error('missing_oauth_redirect');
  }
  window.location.assign(withSelectAccountPrompt(raw));
}

export async function startGoogleOAuth({ signIn, signUp, redirectUrlComplete }) {
  try {
    await startWithResource(signIn, redirectUrlComplete, (params) => signIn.create(params));
  } catch (signInError) {
    try {
      await startWithResource(signUp, redirectUrlComplete, (params) => signUp.create(params));
    } catch {
      throw signInError;
    }
  }
}
